import React from "react"
import ModalButtons from "../ModalButtons/ModalButtons"
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner"
import AssignToCategoryTabContent from "./AssignToCategoryTabContent"
import Tabs from '../Tabs/Tabs';


class AssignToCategory extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      amenities: this.props.amenities,
      all_categories: this.props.all_categories,
      category_id: this.props.category_id || null,
      loading: false,
      active_tab: 'general',
   }
   this.onChangeCategory = this.onChangeCategory.bind(this)
   this.onSave = this.onSave.bind(this)
  }

  render() {
    var self = this
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: [
          'data-dismiss="modal"'
        ]
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary'],
        onClick: function (e) {
          e.stopPropagation()
          e.preventDefault()

          self.onSave()
        }
      }
    ]
    
    return(
      <div className="assign-to-category">
        <div className="panel panel-form">
          <Tabs tabs={this.tabs()} displayErrorMessage={false} />
          <AssignToCategoryTabContent {...this.state}
            onChangeCategory={this.onChangeCategory}
          />
        </div>


        <LoadingSpinner show={this.state.loading} />
        <ModalButtons loading={this.state.loading} buttons={buttons} />
      </div>

    )
  }

  tabs() {
    return (
        [
          {
            tabName: I18n.t('general'),
            targetName: 'general',
            classes: this.state.active_tab === 'general' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
          },
        ]
    );
  };

  onSave() {
    var self = this;

    self.setState({loading: true})
    $.ajax({
      type: 'POST',
      url: self.props.form_action,
      data: {
        amenity_ids: self.props.amenities.map((amenity) => { return amenity.id}),
        category_id: self.state.category_id,
      },
    }).done(function(data) {
      if (data.errors && data.errors.length) {
        self.setState({errors: {category: data.errors}, loading:false})
      } else {
        if (parent && parent.refresh_data) {
          parent.refresh_data(I18n.t("rentals_united_amenitites_assigned_to_category"))
        }

        window.parent.$(window.parent).trigger("rentals_united_amenitites_assigned_to_category")
        
        if (parent && parent.hide_modal) {
          parent.hide_modal();
        }
      }
    })
  }

  onChangeCategory(e) {
    this.setState({category_id: e.target.value})
  }

  onChangeActiveTab(active_tab) {

    this.setState({active_tab: active_tab})
  }
}

export default AssignToCategory
